import React, { useState } from 'react';
import aboutUsData from '../data/about-us.json';
import { LazyLoadImage } from "react-lazy-load-image-component";


const AboutUs = (props) => {
    const [aboutUs, setAboutUsData] = useState(aboutUsData || []);
    return (
        <>
            <div className='relative'>
                <div className="md:block hidden">
                    <img
                        className="object-cover w-screen home-img"
                        src="/assets/static/images/about-us-01.jpg"
                        alt=""
                    />
                </div>
                <div className="md:hidden block">
                    <img
                        className="object-cover w-screen banner-img"
                        src="/assets/static/images/about-us-01.jpg"
                        alt=""
                    />
                </div>
                <div className='absolute top-0 h-1/2 md:h-3/4'>
                    <div className='relative h-full flex flex-col items-start justify-center px-4 md:px-8 lg:px-20 my-4'>
                        <h1 className='px-6 text-white md:px-8 lg:px-20 w-full' style={{ textShadow: '3px 6px 5px #808080' }}>
                            Long History<br /> Of Creating Future
                        </h1>
                    </div>
                </div>
            </div>

            <div id="story" className="lg:scroll-m-32 scroll-m-16 flex lg:flex-row flex-col-reverse dinshaw-card--sm">
                <div className="lg:w-1/2">
                    <img className="h-full object-cover object-right w-screen card-img"
                        src="/assets/static/images/about-us-02.jpg"
                        alt=""
                    />
                </div>
                <div className="lg:w-1/2">
                    <div className="bg-dinshaw-secondary flex flex-col justify-center text-center items-center h-full w-full px-2 py-2 lg:py-8 lg:px-4">
                        <h2 data-aos="fade-up" className="text-dinshaw-yellow p-2 lg:px-16">
                            Persistent Pursuit of Performance & Perfection
                        </h2>
                        <div data-aos-duration="1500" className="text-white w-full sm:w-5/6 px-8 p-2 lg:p-4">
                            <p data-aos="zoom-in">
                                Today, what you see as a one of the fast-growing food-based conglomerates in India, was once just a dream of two enterprising brothers, Dinshaw and Erachshaw Rana. They envisioned an ethical & efficient company that made only the tastiest & purest of products…wrapped in love! Their unrelenting emphasis on superlative quality and innovation with newest & freshest flavours brought forth ice creams that truly were delectable & delightful, as they continue to be today.
                            </p>
                            <p data-aos="zoom-in" className='mt-2 lg:mt-6'>
                                Their success led Dinshaw's to expand into several product categories, and gradually become what it is today!
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div id="presence" className='lg:scroll-m-32 scroll-m-16 flex flex-col justify-center text-center bg-dinshaw-light-blue items-center h-full w-full py-8 lg:py-16 px-8'>
                <h2 data-aos="fade-up" className="text-dinshaw-secondary lg:w-3/4 w-full">
                    Present everywhere, including your heart
                </h2>
                <div data-aos-duration="1500" className="text-black font--bold w-full sm:w-5/6 lg:w-1/2 px-8 p-2 sm:p-4">
                    <p data-aos="zoom-in">
                        Today, Dinshaw’s products are available in most parts of India, and are constantly expanding to new territories.
                    </p>
                    <p data-aos="zoom-in" className='pt-4'>With our strong presence in Maharashtra, Madhya Pradesh, Chhattisgarh, West Bengal, Orissa, Andhra Pradesh, Telangana, Karnataka, Goa, Uttar Pradesh and Jharkhand we’ve been successfully adding wholesome goodness of ‘pure health & taste’ to the lives of thousands since decades.</p>
                </div>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4">
                <LazyLoadImage className="h-full object-cover w-full img-grid"
                    src="/assets/static/images/about-us-03.jpg"
                    alt=""
                />
                <LazyLoadImage className="h-full object-cover w-full img-grid"
                    src="/assets/static/images/about-us-04.jpg"
                    alt=""
                />
                <LazyLoadImage className="h-full object-cover w-full img-grid"
                    src="/assets/static/images/AboutUs-05.jpg"
                    alt=""
                />
                <LazyLoadImage className="h-full object-cover w-full img-grid"
                    src="/assets/static/images/AboutUs-06.jpg"
                    alt=""
                />
            </div>

            <div id="values" className='lg:scroll-m-32 scroll-m-16 flex flex-col justify-center text-center items-center h-full w-full my-4 lg:my-8 md:px-8 lg:px-16'>
                <h2 className="text-dinshaw-secondary py-4 lg:py-6 w-5/6">
                    {aboutUs.coreValues.header}
                </h2>
                <div className='lg:grid-cols-3 grid-rows gap-2 lg:gap-0 justify-center text-center items-start grid landscape:hidden'>
                    {
                        aboutUs.coreValues.content.map((value, index) => (
                            <div key={index} className="text-white h-full mx-2 lg:m-0 lg:p-8 p-4 values-padding" style={{ 'backgroundColor': value.bgColor }}>
                                <LazyLoadImage className="h-full object-cover object-center w-full landscape:hidden"
                                    style={{
                                        height: "40vh",
                                        width: "100%"
                                    }}
                                    src={value.imageUrl}
                                    alt=""
                                />
                                <LazyLoadImage className="h-full object-top object-cover w-full portrait:hidden"
                                   style={{
                                    height: "auto",
                                    width: "100%"
                                }}
                                    src={value.imageUrl}
                                    alt=""
                                />
                                <h3 className="py-4">{value.header}</h3>
                                <p className='pt-0 lg:pt-2 font-normal px-4 text-slate-200'>
                                    {value.content}
                                </p>
                            </div>
                        ))
                    }
                </div>

                <div className='grid-cols-3 gap-2 lg:gap-0 justify-center text-center items-start grid portrait:hidden'>
                    {
                        aboutUs.coreValues.content.map((value, index) => (
                            <div key={index} className="text-white h-full mx-2 lg:m-0 lg:p-8 p-4 values-padding" style={{ 'backgroundColor': value.bgColor }}>
                                <LazyLoadImage className="h-full object-cover object-center w-full"
                                    style={{
                                        height: "auto",
                                        width: "100%"
                                    }}
                                    src={value.imageUrl}
                                    alt=""
                                />                              
                                <h3 className="py-4">{value.header}</h3>
                                <p className='pt-0 lg:pt-2 font-normal px-4 text-slate-200'>
                                    {value.content}
                                </p>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div id="manufacturing" className='lg:scroll-m-32 scroll-m-16 w-full p-8 bg-dinshaw-green'>
                <div className='flex flex-col justify-center text-center text-white'>
                    <h2 className='my-4'>
                        Manufacturing Prowess
                    </h2>
                    <div className='flex justify-center'>
                        <p className='w-1/2 mt-4 mb-8'>
                            Our success lies in our ability to produce excellent products in a high-tech manufacturing facility. Latest machines coupled with the legacy of superlative skills enable us to deliver the taste & quality, you’ve fallen in love with!
                        </p>
                    </div>
                </div>
            </div>

           
            <div id="mission" className="lg:scroll-m-32 scroll-m-16 flex lg:flex-row flex-col-reverse dinshaw-card--sm">
                <div className="lg:w-1/2">
                    <LazyLoadImage className="h-full object-cover object-right w-full card-img"
                        src="/assets/static/images/about us-10.jpg"
                        alt=""
                    />
                </div>
                <div className="lg:w-1/2">
                    <div className="h-full w-full flex flex-col justify-center text-center items-center bg-dinshaw-blue-700 leading-none py-4 md:px-12">
                        <h2 data-aos="fade-up" className="text-white">
                            Our Mission
                        </h2>
                        <div className="text-white pt-4">
                            <div data-aos="zoom-in">
                                <p className='p-2'>
                                    We are together here to delight and satisfy all consumers by continuous improvement of
                                </p>
                                <h4 className='text-sm md:text-base lg:text-2xl lg:m-2 my-2 lg:my-16 lg:px-8 flex flex-col md:flex-row justify-around'>
                                    <span className='flex flex-row  items-center m-2 ml-8 md:m-0'>
                                        <LazyLoadImage className="w-8 md:w-14 h:8 md:h-14 mx-2"
                                            src="/assets/static/images/Our mission icons-02.png"
                                            alt=""
                                        /> Product Quality</span>
                                    <span className='flex flex-row items-center m-2 ml-8 md:m-0'>
                                        <LazyLoadImage className="w-8 md:w-14 h-8 md:h-14 mx-2"
                                            src="/assets/static/images/Our mission icons-03.png"
                                            alt=""
                                        /> Product Innovation</span>
                                    <span className='flex flex-row items-center m-2 ml-8 md:m-0'>
                                        <LazyLoadImage className="w-8 md:w-14 h-8 md:h-14 mx-2"
                                            src="/assets/static/images/Our mission icons-04.png"
                                            alt=""
                                        /> Product Presentation</span>
                                </h4>
                                <p className='p-2'>
                                    which shall be achieved by employing a blend of artisan skills and use of modern technology.
                                </p>
                            </div>
                            <p data-aos="zoom-in" className='p-2'>
                                We strive to provide wholesome products to all segments of the society and thereby contribute to its general health.
                            </p>
                            <p data-aos="zoom-in" className='p-2'>
                                We believe that delighting and bringing joy to our customers gives real meaning to our business.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <section id="certification" className='lg:scroll-m-32 scroll-m-16 flex flex-col justify-center items-center text-center my-4 lg:my-16 mx-2'>
                <h2 className='my-4 text-dinshaw-gold'>Certified For Quality & Competence</h2>
                <p className='font-bold mt-2 mb-8 lg:w-1/2 w-5/6'>
                    At Dinshaw’s all products are rigorously tested in world-class NABL accredited laboratories on strictest of quality parameters before they reach you.
                </p>

                <div className='grid grid-cols-2'>
                    <div data-aos="fade-right" className='flex flex-col justify-start lg:justify-center items-center'>
                        <LazyLoadImage className="lg:h-80 h-32 lg:w-96 w-40"
                            src="/assets/static/images/about us-11.jpg"
                            alt=""
                        />
                        <p className='font-bold px-2 lg:px-40'>
                            Certificate on Food Safety System Certificate -
                            FSSC 22000 from Bureau Veritas Certifications Co.
                        </p>
                    </div>
                    <div data-aos="fade-left" className='flex flex-col justify-start lg:justify-center items-center'>
                        <LazyLoadImage className="lg:h-80 h-32 lg:w-96 w-40"
                            src="/assets/static/images/about us-12.jpg"
                            alt=""
                        />
                        <p className='font-bold px-2 lg:px-40'>
                            Approved by National Accreditation Board for Testing and Calibration Laboratories
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AboutUs;